export default {
  error_title: 'Error',
  // TKT-2149: configuracion de ubicacion estricta (ExtraSettings)
  mock_toggle_label: 'Habilitar la validación estricta de ubicación (bloquea apps que alteran el GPS).',
  mock_disable_confirm: '¿Está seguro de deshabilitar la validación estricta de ubicación?, se podrá continuar con el GPS alterado.',
  mock_admin_only: 'Solo un administrador de la organización puede cambiar la validación estricta de ubicación.',
  mock_invalid_enabled: 'El valor de la validación estricta de ubicación no es válido. Recarga la página e inténtalo de nuevo.',
  report_title: 'Descargar el Reporte de Ubicación Estricta',
  report_date: 'Fecha',
  report_from: 'Inicio',
  report_to: 'Final',
  report_close: 'Cerrar',
  report_download: 'Descargar',
  report_invalid_dates: 'Selecciona una fecha de inicio y una fecha final válidas.',
  report_from_after_to: 'La fecha de inicio no puede ser mayor a la fecha final.',
  report_admin_only: 'Solo un administrador de la organización puede descargar este reporte.',
  report_error: 'No se pudo generar el reporte. Inténtalo de nuevo.',
  mock_notify_title: 'Destinatarios Adicionales',
  mock_notify_hint: 'Seleccionar otro rol para notificar alertas (Opcional)',
  mock_notify_placeholder: 'Selecciona un rol..',
  mock_notify_admin_only: 'Solo el administrador de la organización puede cambiar los destinatarios adicionales.',
  mock_notify_invalid_role: 'El rol seleccionado ya no está disponible. Elige otro rol de la organización.',
  report_end_after_today: 'La fecha final no puede ser mayor al día de hoy.',
  settings_save_error: 'No se pudieron guardar las configuraciones. Inténtalo de nuevo.',
  mock_blocked_title: 'Se ha bloqueado esta actividad',
  mock_blocked: 'Detectamos que estás usando una herramienta para esconder desde dónde te conectas.',
  mock_blocked_note: 'Esta actividad será bloqueada.',
  mock_blocked_ok: 'Entendido',
  blocked_out_of_area: 'No estás en la ubicación correcta para contestar este formulario. Acércate al sitio asignado e inténtalo de nuevo.',
  blocked_unavailable: 'No pudimos obtener tu ubicación. Revisa que el GPS esté encendido e inténtalo de nuevo.',
  blocked_dismiss: 'Entendido',
  permission_denied: 'El dispositivo no ha permitido obtener la ubicación. Revise los permisos.',
  precise_location_required: 'Necesitamos tu ubicación precisa. Abre los permisos de la app y cambia «Aproximada» por «Precisa».',
  position_unavailable: 'No pudimos obtener tu ubicación. Revisa que el GPS esté encendido y vuelve a intentarlo.',
  timeout: 'El GPS está tardando demasiado en responder.'
}
